
import { Component, Prop, Vue } from "vue-property-decorator";
import Util from "@/ts/Util";

@Component({
  props: { image: String, text: String, desc: String },
})
export default class EmptyState extends Vue {
  /*private img: string = "";

  mounted() {
    if (this.$props.image == "" || this.$props.image === null)
      this.img = Util.getImgUrl("placeholder", ".png");
    else this.img = Util.getImgUrl(this.$props.image, ".svg");
  }*/
}
